import { CONTACT } from "@/data/landingData";
import { useLanguage } from "@/context/LanguageContext";

const ContactMap = () => {
  const { copy } = useLanguage();

  return (
    <div className="contact-map" data-testid="contact-map">
      <p className="section-kicker" data-testid="contact-map-kicker">
        {copy.contact.mapKicker}
      </p>
      <h3 className="contact-map-title" data-testid="contact-map-title">
        {copy.contact.mapTitle}
      </h3>
      <div className="contact-map-frame" data-testid="contact-map-frame">
        <iframe
          title={copy.contact.mapTitle}
          src={CONTACT.mapEmbed}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
        <a
          href={CONTACT.mapLink}
          target="_blank"
          rel="noreferrer"
          className="contact-map-overlay"
          data-testid="contact-map-overlay"
          aria-label={copy.contact.mapCta}
        />
      </div>
      <div className="contact-map-actions" data-testid="contact-map-actions">
        <a
          href={CONTACT.mapLink}
          target="_blank"
          rel="noreferrer"
          className="text-link"
          data-testid="contact-map-link"
        >
          {copy.contact.mapCta}
        </a>
        <a
          href={CONTACT.mapDirections}
          target="_blank"
          rel="noreferrer"
          className="text-link map-direction-button"
          data-testid="contact-map-directions"
        >
          {copy.contact.mapDirections}
        </a>
      </div>
    </div>
  );
};

export default ContactMap;
